import React from "react";
import AuthorizationHook from "hooks/authorization";
import styles from "./authorization.module.scss";
import logoImg from "../../assets/img/logo.svg";
import spinnerImg from "../../assets/img/spinner.svg";

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export function Authorization() {
    AuthorizationHook();

    return (
        <div className={styles.container}>
            <div>
                <img src={logoImg} alt="" />
            </div>

            <div className={styles.container__loading}>
                <img src={spinnerImg} alt="" width={130} height={130} />

                <span className={styles.container__loading__text}>
                    Aguarde um instante
                </span>
            </div>
        </div>
    );
}
